import * as yup from 'yup'

const REQUIRED_FIELD_MESSAGE = 'Campo requerido'
const INVALID_DATE_MESSAGE = 'Fecha invalida'
const MIN_DATE_MESSAGE = 'La fecha debe ser hoy o posterior'
const END_DATE_ORDER_MESSAGE = 'La fecha de fin debe ser igual o posterior a la fecha de inicio'
const DATE_RANGE_MAX_MONTH_MESSAGE = 'El rango de fechas no puede superar los 2 meses'
const TIME_RANGE_PAIR_MESSAGE = 'Debes seleccionar ambas horas o ninguna'
const TIME_RANGE_ORDER_MESSAGE = 'La hora desde debe ser menor o igual a la hora hasta'

const toMinutes = date => {
	if (!date) return null
	const parsedDate = new Date(date)
	if (Number.isNaN(parsedDate.getTime())) return null
	return parsedDate.getHours() * 60 + parsedDate.getMinutes()
}

const addMonthsPreservingDay = (date, monthsToAdd = 1) => {
	if (!date) return null
	const sourceDate = new Date(date)
	if (Number.isNaN(sourceDate.getTime())) return null

	const sourceDay = sourceDate.getDate()
	const result = new Date(sourceDate)
	result.setDate(1)
	result.setMonth(result.getMonth() + monthsToAdd)

	const lastDayOfTargetMonth = new Date(
		result.getFullYear(),
		result.getMonth() + 1,
		0
	).getDate()

	result.setDate(Math.min(sourceDay, lastDayOfTargetMonth))
	return result
}

const today = new Date()
today.setHours(0, 0, 0, 0)

const baseAppointmentFields = {
	speciality: yup.string().required(REQUIRED_FIELD_MESSAGE),
	clinic: yup
		.array()
		.of(yup.string())
		.min(1, REQUIRED_FIELD_MESSAGE),
	professional: yup.string().nullable()
}

export const validationsInitialForm = yup.object().shape({
	...baseAppointmentFields
})

export const validationsMultipleAppointments = yup.object().shape({
	...baseAppointmentFields,
	startDate: yup
		.date()
		.nullable()
		.typeError(INVALID_DATE_MESSAGE)
		.min(today, MIN_DATE_MESSAGE),
	endDate: yup
		.date()
		.nullable()
		.typeError(INVALID_DATE_MESSAGE)
		.min(today, MIN_DATE_MESSAGE)
		.when('startDate', (startDate, schema) => {
			return startDate ? schema.min(startDate, END_DATE_ORDER_MESSAGE) : schema
		})
		.test('date-range-max-month', DATE_RANGE_MAX_MONTH_MESSAGE, function(endDate) {
			const { startDate } = this.parent
			if (!startDate || !endDate) return true
			const maxAllowedEndDate = addMonthsPreservingDay(startDate, 2)
			if (!maxAllowedEndDate) return true
			return new Date(endDate) <= maxAllowedEndDate
		}),
	hourFrom: yup
		.date()
		.nullable()
		.typeError(INVALID_DATE_MESSAGE)
		.test('hour-range-pair-from', TIME_RANGE_PAIR_MESSAGE, function(hourFrom) {
			const { hourTo } = this.parent
			return (!hourFrom && !hourTo) || (hourFrom && hourTo)
		}),
	hourTo: yup
		.date()
		.nullable()
		.typeError(INVALID_DATE_MESSAGE)
		.test('hour-range-pair-to', TIME_RANGE_PAIR_MESSAGE, function(hourTo) {
			const { hourFrom } = this.parent
			return (!hourFrom && !hourTo) || (hourFrom && hourTo)
		})
		.test('hour-range-order', TIME_RANGE_ORDER_MESSAGE, function(hourTo) {
			const { hourFrom } = this.parent
			if (!hourFrom || !hourTo) return true
			const hourFromMinutes = toMinutes(hourFrom)
			const hourToMinutes = toMinutes(hourTo)
			if (hourFromMinutes == null || hourToMinutes == null) return true
			return hourFromMinutes <= hourToMinutes
		})
})

export default validationsInitialForm
